import { Box } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { ListarInformacoesTelaIcms } from '../../../services/api'
import FiltroContabilidade from './components/FiltroContabilidade'
import TabelaContabilidade from './components/TabelaContabilidade'
import * as S from './styles'

const Contabilidade = () => {
    const [dados, setDados] = useState([])
    const [form_data_entrada, setform_data_entrada] = useState('')
    const [form_data_saida, setform_data_saida] = useState('')
    const [form_numero_pedido, setform_numero_pedido] = useState('')
    const [pendencia, setpendencia] = useState('2')
    const [dataDeUp, setdataDeUp] = useState(false)
    const [dataAteUp, setdataAteUp] = useState(false)
    const [loading, setLoading] = useState(false)
    const [noteView, setNoteView] = useState()

    const [filter, setFilter] = useState({
        numero_pedido: '',
        data_entrada: '',
        data_saida: '',
        pendencia: '3',
    })

    async function handleFilterValues() {
        const { data_entrada, data_saida } = filter

        const dataEntradaFormatada = data_entrada.split('-').reverse().join('/')
        const dataSaidaFormatada = data_saida.split('-').reverse().join('/')

        console.log(dataEntradaFormatada, dataSaidaFormatada)

        const { data } = await ListarInformacoesTelaIcms.post('', filter)

        const orderData = data.sort((a, b) => {
            return a.data_solicitacao > b.data_solicitacao ? -1 : a.data_solicitacao < b.data_solicitacao ? 1 : 0
        })

        console.log('orderData', orderData)

        setDados(orderData)
    }

    useEffect(() => {
        setFilter({
            ...filter,
            pendencia: '3',
        })

        handleFilterValues()
    }, [])

    //iniciar a pagina com os dados pendentes

    useEffect(() => {
        setLoading(true)
        const timer = setTimeout(() => {
            setLoading(false)
            clearTimeout(timer)
        }, 2000)
    }, [dados])

    return (
        <>
            <Box h={'100vh'}>
                <S.ContabilidadeContainerText>
                    <h1>
                        <strong>CONTABILIDADE</strong>
                    </h1>
                </S.ContabilidadeContainerText>
                <FiltroContabilidade
                    setFilter={setFilter}
                    filter={filter}
                    noteView={noteView}
                    dataAteUp={dataAteUp}
                    dataDeUp={dataDeUp}
                    pendencia={pendencia}
                    setpendencia={setpendencia}
                    form_numero_pedido={form_numero_pedido}
                    form_data_saida={form_data_saida}
                    form_data_entrada={form_data_entrada}
                    setform_data_entrada={setform_data_entrada}
                    setform_data_saida={setform_data_saida}
                    setform_numero_pedido={setform_numero_pedido}
                    handleFilterValues={handleFilterValues}
                />

                <TabelaContabilidade loading={loading} noteView={noteView} dados={dados} />
            </Box>
        </>
    )
}

export default Contabilidade
